export const baseSpacingPixelValue = 4;
export const spacing = (...x) => {
    return x.map(n => `${n * baseSpacingPixelValue}px`).join(' ');
};
export const borderRadius = {
    interaction: '4px',
    element: '8px',
};
//# sourceMappingURL=spacing.js.map